<template>
  <div>
    <v-dialog v-model="showSortProduct" persistent scrollable>
      <template v-slot:activator="{ on }">
        <v-btn outline color="primary" v-on="on">
          <v-icon class="mr-2">swap_vert</v-icon>
          {{ $t('sort product') }}
        </v-btn>
      </template>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat @click="onClose" small>
            <v-icon>close</v-icon>
          </v-btn>
          <v-divider></v-divider>
        </div>
        <v-card-text class="ma-0" style="height: 600px;">
          <div class="text-xs-center">
            <v-pagination
              v-model="pageNumber"
              :length="pageCount"
              @input="onClickPageinate"
              class="mb-2"
            ></v-pagination>
          </div>
          <div style="min-height: 400px" v-if="loadingProduct || loading">
            <v-layout style="height: 400px" justify-center align-center row>
              <v-flex class="text-xs-center">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </div>
          <template v-else>
            <v-container>
              <v-layout wrap>
                <template v-for="(product, index) in filterProducts">
                  <v-flex xs6 sm3 xl2 class="pa-1" :key="product.id">
                    <sort-product-item
                      v-model="filterProducts[index]"
                      :key="'product_' + product.id"
                    >
                      <move-vertical
                        slot="move"
                        :index="(pageNumber - 1) * size + index"
                        :max="products.length"
                        @onMove="onMove(product.id, $event)"
                        :showForward="true"
                      ></move-vertical>
                    </sort-product-item>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </template>

          <div class="text-xs-center">
            <v-pagination
              v-model="pageNumber"
              :length="pageCount"
              @input="onClickPageinate"
              class="mb-2"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SortProductItem from './SortProductItem'
import MoveVertical from '@/components/elements/MoveVertical2'
import api from '@/api'
export default {
  data() {
    return {
      showSortProduct: false,
      sortproducts: [],
      loading: true,
      isNoSort: false,
      isChange: false,
      pageNumber: 1,
      size: 10,
      productCount: 0
    }
  },
  components: {
    SortProductItem,
    MoveVertical
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    filterProducts() {
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return this.sortproducts.slice(start, end)
    },
    pageCount: function() {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  async mounted() {
    this.isNoSort = false
    await this.$store.dispatch('loadProducts')
    this.sortproducts = this.products
    this.productCount = this.sortproducts.length
    this.sortproducts.map((product, index) => {
      if (product.priority == 0) this.isNoSort = true
      this.$set(this.sortproducts[index], 'priority', index + 1)
    })
    if (this.isNoSort) {
      this.checkMove(true)
    }
    this.loading = false
  },
  methods: {
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClose() {
      if (this.isChange) this.$emit('onChangeProduct')
      this.showSortProduct = false
    },
    onMove(id, direction) {
      var vm = this
      var index = vm.sortproducts.findIndex(el => {
        return el.id == id
      })
      if (index != -1) {
        if (direction == 'up') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index - 1, 1)[0])
          this.checkMove(false, [index, index - 1])
        } else if (direction == 'down') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index + 1, 1)[0])
          this.checkMove(false, [index, index + 1])
        } else if (direction == 'top') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.unshift(product)
          let listindex = []
          for (let c = 0; c <= index; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        } else if (direction == 'bottom') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.push(product)
          let listindex = []
          for (let c = index; c < vm.sortproducts.length; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        }
      } else {
      }
    },
    checkMove: function(isAll, list) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      if (isAll) {
        input = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })
      } else {
        let priority = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })

        input = priority.filter((el, index) => {
          return list.includes(index)
        })
      }

      if (input.length > 0) {
        api.putpriorityproducts({ input, pageid: this.selectedBot.pageid }, function(
          error,
          response
        ) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }
          vm.isChange = true
        })
      }
    }
  },
  watch: {
    showSortProduct: function(newVal, oldVal) {
      if (!newVal && oldVal) this.isChange = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SortProduct.vue